"use client";

import { BarChart3, Lock, Shield, Users } from "lucide-react";
import { useJsonTranslation } from "@/hooks/useJsonTranslation";

const items = [
  {
    icon: Shield,
    titleKey: "items.soc2.title",
    descKey: "items.soc2.description",
  },
  {
    icon: Lock,
    titleKey: "items.encryption.title",
    descKey: "items.encryption.description",
  },
  {
    icon: Users,
    titleKey: "items.privacy.title",
    descKey: "items.privacy.description",
  },
  {
    icon: BarChart3,
    titleKey: "items.uptime.title",
    descKey: "items.uptime.description",
  },
];

export function Trust() {
  const { t } = useJsonTranslation("HomeTrust");

  return (
    <div
      data-home-block="trust-grid"
      className="relative px-5 py-8 sm:px-7 sm:py-10"
    >
      <div>
        <div className="mb-10 text-center">
          <div className="text-leaf-600 dark:text-leaf-400 mb-4 text-[11px] font-semibold tracking-[0.32em] uppercase">
            {t("eyebrow")}
          </div>
          <h2 className="font-home-display text-foreground text-3xl font-semibold tracking-normal text-balance md:text-4xl">
            {t("title")}
          </h2>
          <p className="text-muted-foreground/70 mx-auto mt-5 max-w-2xl text-lg text-pretty">
            {t("subtitle")}
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, i) => (
            <div
              key={i}
              className="uni-card group relative overflow-hidden text-center"
            >
              <div
                className="pointer-events-none absolute -top-14 left-1/2 h-28 w-28 -translate-x-1/2 rounded-full opacity-0 blur-2xl transition-opacity duration-300 group-hover:opacity-60"
                style={{
                  background:
                    "radial-gradient(circle, rgba(52,211,153,0.45), transparent 70%)",
                }}
                aria-hidden="true"
              />
              <div className="bg-surface-success border-surface-success-border text-leaf-700 dark:text-leaf-300 mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-xl border shadow-[0_12px_28px_-14px_rgba(52,211,153,0.6)] transition-transform duration-300 group-hover:scale-110">
                <item.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <h3 className="font-display text-foreground mb-2 font-semibold">
                {t(item.titleKey)}
              </h3>
              <p className="text-muted-foreground/70 text-sm leading-relaxed">
                {t(item.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
